import type { IMasterDataProductCategoryRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataProductCategoryDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataProductCategoryUseCase {
  private readonly repository: IMasterDataProductCategoryRepository;

  constructor(repository: IMasterDataProductCategoryRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataProductCategoryDTO) {
    return this.repository.updateProductCategory(params);
  }
}
